import {CdkDrag, CdkDropList} from '@angular/cdk/drag-drop';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {RouterLink} from '@angular/router';
import {
  NbAccordionModule,
  NbActionsModule,
  NbBadgeModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbDatepickerModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbListModule,
  NbRadioModule,
  NbSelectModule,
  NbSpinnerModule,
  NbTabsetModule,
  NbTagModule,
  NbToggleModule,
  NbTooltipModule
} from '@nebular/theme';
import {NgSelectModule} from '@ng-select/ng-select';
import {FormlyBootstrapModule} from '@ngx-formly/bootstrap';
import {FormlyModule} from '@ngx-formly/core';
import {TuiButton, TuiScrollable, TuiScrollbar} from '@taiga-ui/core';
import {TuiEditor} from '@taiga-ui/editor';
import {TuiCarouselComponent, TuiPagination} from '@taiga-ui/kit';
import {SharedModule} from 'compob2b-libs';
import {TableModule} from 'compob2b-table';
import {FileUploadModule} from 'ng2-file-upload';
import {NgxPaginationModule} from 'ngx-pagination';
import {BaseModule} from '../../../../../../compob2b-table/lib/components/base/base.module';
import {AdminSharedModule} from '../../../admin-shared/admin-shared.module';
import {BreadcrumbsComponent} from '../../../admin-shared/breadcrumbs/breadcrumbs.component';
import {
  DamChooseCatalogInputComponent
} from '../../../admin-shared/custom-form-types/dam-choose-catalog-input/dam-choose-catalog-input.component';
import {DamRelatedCollectionComponent} from '../dam-related-collection/dam-related-collection.component';
import {DamSearchElasticComponent} from '../dam-search-elastic/dam-search-elastic.component';
import {DamUnitItemsComponent} from '../dam-unit-items/dam-unit-items.component';
import {DialogWrapperComponent} from '../dialog-wrapper/dialog-wrapper.component';
import {DropdownComponent} from '../dropdown/dropdown.component';
import {FileUploadComponent} from '../file-upload/file-upload.component';
import {SecuredImageComponent} from '../secured-image/secured-image.component';
import {ViewChangingTabsComponent} from '../view-changing-tabs/view-changing-tabs.component';
import {AttachedElementsComponent} from './create-update/attached-elements/attached-elements.component';
import {CreateUpdateFilesComponent} from './create-update/create-update-files.component';
import {DamItemInfoViewComponent} from './create-update/dam-item-page-tabs/info-tab/dam-item-info-view/dam-item-info-view.component';
import {DamItemParamsComponent} from './create-update/dam-item-page-tabs/info-tab/dam-item-params/dam-item-params.component';
import {DamItemVersionsComponent} from './create-update/dam-item-page-tabs/info-tab/dam-item-versions/dam-item-versions.component';
import {DamItemTemplateFeaturesComponent} from './create-update/dam-item-template-features/dam-item-template-features.component';
import {TfBooleanComponent} from './create-update/dam-item-template-features/types/tf-boolean/tf-boolean.component';
import {TfDateComponent} from './create-update/dam-item-template-features/types/tf-date/tf-date.component';
import {TfHtmlComponent} from './create-update/dam-item-template-features/types/tf-html/tf-html.component';
import {TfIntervalComponent} from './create-update/dam-item-template-features/types/tf-interval/tf-interval.component';
import {TfLinkComponent} from './create-update/dam-item-template-features/types/tf-link/tf-link.component';
import {TfRangeComponent} from './create-update/dam-item-template-features/types/tf-range/tf-range.component';
import {TfSelectComponent} from './create-update/dam-item-template-features/types/tf-select/tf-select.component';
import {TfSizeComponent} from './create-update/dam-item-template-features/types/tf-size/tf-size.component';
import {TfSmartlistComponent} from './create-update/dam-item-template-features/types/tf-smartlist/tf-smartlist.component';
import {TfStringComponent} from './create-update/dam-item-template-features/types/tf-string/tf-string.component';
import {DamCatalogsLinksModalComponent} from './dam-catalogs-links-modal/dam-catalogs-links-modal.component';
import {DamCatalogsLinksComponent} from './dam-catalogs-links/dam-catalogs-links.component';
import {DamFavoritesComponent} from './dam-favorites/dam-favorites.component';
import {DamItemPersonComponent} from './dam-item-person/dam-item-person.component';
import {DamItemShowPersonComponent} from './dam-item-show-person/dam-item-show-person.component';
import {DamItemVersionsHistoryComponent} from './dam-item-versions-history/dam-item-versions-history.component';
import {DamItemVersionsTransformationComponent} from './dam-item-versions-transformation/dam-item-versions-transformation.component';
import {DamPreviewImageComponent} from './dam-preview-image/dam-preview-image.component';
import {DamPreviewTextComponent} from './dam-preview-text/dam-preview-text.component';
import {DamPreviewVideoComponent} from './dam-preview-video/dam-preview-video.component';
import {DamElementPreviewComponent} from './dam-table/components/dam-element-preview/dam-element-preview.component';
import {DamFiltersComponent} from './dam-table/components/dam-filters/dam-filters.component';
import {SelectedFiltersComponent} from './dam-table/components/filter-components/selected-filters/selected-filters.component';
import {SidebarFiltersComponent} from './dam-table/components/filter-components/sidebar-filters/sidebar-filters.component';
import {PlatesViewComponent} from './dam-table/components/plates-view/plates-view.component';
import {DamCatalogComponent} from './dam-table/dam-catalog.component';

import {FilesRoutingModule} from './files-routing.module';
import {DamFilesListComponent} from './list/dam-files-list.component';
import {PermissionsComponent} from './permissions/permissions.component';

import {ShareDamTableComponent} from './share-dam-table/share-dam-table.component';
import {ShareDamFilesListComponent} from './share-list/share-dam-files-list.component';

@NgModule({
  declarations: [
    DamFilesListComponent,
    CreateUpdateFilesComponent,
    DamFavoritesComponent,
    PermissionsComponent,
    DamCatalogComponent,
    SelectedFiltersComponent,
    FileUploadComponent,
    ShareDamTableComponent,
    DamItemVersionsComponent,
    ShareDamFilesListComponent,
    DamPreviewTextComponent,
    DamPreviewImageComponent,
    DamPreviewVideoComponent,
    DamCatalogsLinksComponent,
    DamCatalogsLinksModalComponent,
    DamItemTemplateFeaturesComponent,
    DamItemVersionsHistoryComponent,
    TfSelectComponent,
    TfBooleanComponent,
    TfDateComponent,
    TfRangeComponent,
    TfIntervalComponent,
    TfStringComponent,
    TfHtmlComponent,
    TfSizeComponent,
    TfLinkComponent,
    TfSmartlistComponent,
    PlatesViewComponent,
    DamFiltersComponent,
    DamElementPreviewComponent,
    AttachedElementsComponent,
    AttachedElementsComponent,
    DamUnitItemsComponent,
    DamItemInfoViewComponent,
    DamItemInfoViewComponent,
    DamItemParamsComponent,
    DamItemVersionsTransformationComponent,
    DamItemPersonComponent,
    SidebarFiltersComponent,
    DamItemShowPersonComponent
  ],
  exports: [
    DamFilesListComponent,
    DamFavoritesComponent,
    FileUploadComponent,
    SelectedFiltersComponent,
    DamCatalogComponent,
    ShareDamFilesListComponent,
    ShareDamTableComponent,
    DamPreviewTextComponent,
    DamPreviewImageComponent,
    DamPreviewVideoComponent,
    DamCatalogsLinksComponent,
    DamCatalogsLinksModalComponent,
    DamItemTemplateFeaturesComponent,
    DamItemVersionsHistoryComponent,
    DamItemVersionsComponent,
    SidebarFiltersComponent,
    DamUnitItemsComponent
  ],
  imports: [
    CommonModule,
    FilesRoutingModule,
    ReactiveFormsModule,
    AdminSharedModule,
    NbCardModule,
    TableModule,
    NbButtonModule,
    NbIconModule,
    NbActionsModule,
    NbToggleModule,
    NbTooltipModule,
    FormlyModule,
    FormlyBootstrapModule,
    NbSelectModule,
    NbBadgeModule,
    NbSpinnerModule,
    NbCheckboxModule,
    NbDatepickerModule,
    NbListModule,
    NbRadioModule,
    FileUploadModule,
    NbInputModule,
    FormsModule,
    NgxPaginationModule,
    TuiButton,
    NbTabsetModule,
    NbTagModule,
    MatMenuModule,
    MatButtonModule,
    NgSelectModule,
    NbAccordionModule,
    NbFormFieldModule,
    FileUploadModule,
    CdkDropList,
    CdkDrag,
    TuiScrollbar, TuiScrollable, BreadcrumbsComponent, BaseModule, SharedModule, TuiPagination, TuiCarouselComponent, RouterLink, SecuredImageComponent, DamRelatedCollectionComponent, DialogWrapperComponent, ViewChangingTabsComponent, DamSearchElasticComponent, DamChooseCatalogInputComponent, DropdownComponent, TuiEditor,
  ]
})
export class DamFilesModule {
}
